export const CREATE_SALES_INVOICE = gql`
    mutation CreateSalesInvoice($input: CreateSalesInvoiceInput!) {
        createSalesInvoice(input: $input) {
            id
            sageInvoiceNumber
        }
    }
`;
